export default __webpack_public_path__ + "71b6570f27cb857f978d8e52a77fbbad.svg";